import React from 'react';
import { Stars } from './Stars';
import { KindTag } from './KindTag';
import { useLanguage } from '../../contexts/LanguageContext';
import type { ReviewMeta } from '../../data/site';
type ReviewCardProps = {
  review: ReviewMeta;
};
export function ReviewCard({
  review
}: ReviewCardProps) {
  const {
    t
  } = useLanguage();
  const copy = t.reviews.items[review.id];
  return <blockquote className="flex h-full flex-col rounded-2xl border border-petal bg-white p-6 sm:p-7" data-id="element-382" data-mp="3bwd15o0z37ia">
      <div className="flex items-center justify-between gap-3" data-id="element-383" data-mp="36x8scyhynbsh">
        <Stars count={review.rating} label={t.common.starsLabel} data-id="element-384" data-mp="36y1rbdaogx02" />
        <KindTag kind={review.kind} label={t.common.kinds[review.kind]} tone="dark" data-id="element-385" data-mp="32uvlu7ve39un" />
      </div>
      <p className="mt-5 text-[15px] leading-relaxed text-ink/85" data-id="element-386" data-mp="2xxdbqe5myol2">“{copy.quote}”</p>
      <footer className="mt-auto flex items-center gap-3 border-t border-petal/70 pt-5" data-id="element-387" data-mp="1rh1c08n60ynd">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-mauve text-xs font-medium text-white" aria-hidden="true" data-id="element-388" data-mp="1mhopxq44bvlu">
          {review.initials}
        </span>
        <div className="min-w-0" data-id="element-389" data-mp="2iyojxrj14jrr">
          <p className="text-sm font-medium text-ink" data-id="element-390" data-mp="2ixn6jgejjl6v">{review.name}</p>
          <p className="truncate text-xs text-ink/55" data-id="element-391" data-mp="24xlvx98h4ze7">
            {copy.service} · {copy.location} · {copy.date}
          </p>
        </div>
      </footer>
    </blockquote>;
}